import React, { useEffect, useRef, useState } from "react";
import { ChevronDownIcon, FilterIcon } from "lucide-react";
import FyersStraddleHistoryTable from "./fyersStraddleHistoryTable";

// import io from "socket.io-client";

export default function ShowStraddleHistoryData({
  straddleData,
  setStraddleData,
  filteredFyersStraddleHistoryData,
  setFilteredFyersStraddleHistoryData,
  handleResetFilterData,
  sortOrder,
  setSortOrder,
  ...props
}) {
  const [filterDropDownHistory, setFilterDropDownHistory] = useState(false);
  const [filterByDaysHistory, setFilterByDaysHistory] = useState(false);

  const filterByDaysHistoryRef = useRef(null);
  const filterDropDownHistoryRef = useRef(null);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      if (
        filterByDaysHistoryRef.current &&
        !filterByDaysHistoryRef.current.contains(event.target) &&
        filterByDaysHistory
      ) {
        closeFilterByDaysModal();
      }

      if (
        filterDropDownHistoryRef.current &&
        !filterDropDownHistoryRef.current.contains(event.target) &&
        filterDropDownHistory
      ) {
        closeFilterDroprDownModal();
      }
    };

    document.addEventListener("mousedown", handleOutsideClick);

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [filterByDaysHistory, filterDropDownHistory]);

  const showFilterDroprDownModal = () => {
    setFilterDropDownHistory(true);
  };

  const showFilterByDaysModal = () => {
    setFilterByDaysHistory(true);
  };

  const closeFilterDroprDownModal = () => {
    setFilterDropDownHistory(false);
  };

  const closeFilterByDaysModal = () => {
    setFilterByDaysHistory(false);
  };

  const [show, setShow] = useState(false);

  const [state, setState] = useState("FNO");

  return (
    <div className="z-0 relative w-full h-full  overflow-hidden  bg-black">
      <div className="flex justify-between bg-[#0F0F0F] h-[60px] px-6 w-full">
        <div className="flex space-x-6"></div>
        <div className="relative flex space-x-4 items-center ">
          <button
            onClick={() => setShow(true)}
            className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
          >
            <span className="text-white text-base">{state}</span>
            <ChevronDownIcon className="h-5 w-5 text-white" />
          </button>

          {show === true && (
            <div className="z-10 absolute top-16 -left-3 bg-gray-800 w-[160px]  p-1 rounded-sm">
              <div className="flex  flex-col space-y-1 h-full p-2">
                <div
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                  onClick={() => {
                    setState("FNO");
                    setShow(false);
                  }}
                >
                  FNO
                </div>
                <div
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                  onClick={() => {
                    setState("EQUITY");
                    setShow(false);
                  }}
                >
                  EQUITY
                </div>
              </div>
            </div>
          )}

          {/* <button
            ref={filterDropDownHistoryRef}
            onClick={showFilterDroprDownModal}
            className="flex items-center space-x-2 bg-gray-800/40 px-6 py-2.5 rounded-md"
          >
            <FilterIcon className="h-5 w-5 text-white" />
            <span className="text-white text-base">Filter</span>
          </button> */}

          {filterDropDownHistory && (
            <div
              ref={filterDropDownHistoryRef}
              className="absolute top-16 right-0 bg-gray-800 w-[160px]  p-1 rounded-sm"
            >
              <div className="flex  flex-col space-y-1 h-full p-2">
                <div
                  // onClick={handleAllData}
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md "
                >
                  All
                </div>
                <div
                  // onClick={handleFilterByBuyOrders}
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md"
                >
                  Buy Orders
                </div>
                <div
                  // onClick={handleFilterBySellOrders}
                  className="text-white text-base cursor-pointer hover:bg-gray-900 px-2 py-1 rounded-md"
                >
                  Sell Orders
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      <FyersStraddleHistoryTable
        fyersStraddleHistoryData={straddleData}
        setStraddleData={setStraddleData}
        filteredFyersStraddleHistoryData={filteredFyersStraddleHistoryData}
        setFilteredFyersStraddleHistoryData={setFilteredFyersStraddleHistoryData}
        sortOrder={sortOrder}
        setSortOrder={setSortOrder}
        handleResetFilterData={handleResetFilterData}
      />
    </div>
  );
}
